import { createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("学習室入室")
const _hoisted_2 = { class: "flex flex-col items-center text-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h6", { class: "mb-4 font-medium text-gray-700" }, " この端末で学習室に入る場合 ", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "my-8 text-xs" }, "または", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("h6", { class: "mb-2 font-medium text-gray-700" }, " 別の端末で学習室に入る場合 ", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "text-gray-700 text-sm mb-4" }, " QRコードを読み取るか、ブラウザで以下のURLを開いてください ", -1)
const _hoisted_7 = { class: "text-gray-700 text-xs break-all" }
const _hoisted_8 = /*#__PURE__*/_createVNode("svg", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  class: "w-6 h-6",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" })
], -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "上記の方法で入室できない方はこちら", -1)
const _hoisted_10 = {
  key: 0,
  class: "flex flex-col items-center p-4 bg-primary-100 rounded-md text-gray-700 text-sm"
}
const _hoisted_11 = { class: "mb-2 border border-2 border-red-400 rounded-md p-3 bg-white" }
const _hoisted_12 = { class: "flex items-center justify-center text-red-500 mb-2" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", null, "【こちらの入室方法は緊急時のみご利用ください】", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" こちらの入室方法で学習室に入ることはできますが、学習ログが残りません。通常のブラウザ版（LINE 以外から入室）での入室方法は、"),
  /*#__PURE__*/_createVNode("a", {
    href: "https://mingaku.net/guide-student/browser-usage",
    target: "_blank",
    rel: "noopener noreferrer",
    class: "text-primary-500 hover:text-primary-600"
  }, "マニュアル"),
  /*#__PURE__*/_createTextVNode("をご参照ください。 ")
], -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { class: "mb-2" }, " 以下のミーティングIDをZoomアプリに直接入力して参加してください ", -1)
const _hoisted_16 = { class: "mb-2" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" ミーティングID: ")
const _hoisted_18 = { class: "font-medium" }
const _hoisted_19 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("パスワード: "),
  /*#__PURE__*/_createVNode("span", { class: "font-medium" }, "mWSeg-2K")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_MBaseModal = _resolveComponent("MBaseModal")

  return (_openBlock(), _createBlock(_component_MBaseModal, { onClose: _ctx.close }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("a", {
          href: _ctx.url,
          target: "_blank",
          rel: "noopener noreferrer",
          class: "rounded-md px-8 py-2 font-medium bg-primary-500 text-white transition-all duration-300 cursor-pointer hover:bg-primary-600"
        }, " 入室 ", 8, ["href"]),
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createVNode(_component_qrcode_vue, {
          class: "bg-gray-100 p-4 mb-4 rounded-md",
          value: _ctx.url,
          size: "200",
          level: "H"
        }, null, 8, ["value"]),
        _createVNode("span", _hoisted_7, _toDisplayString(_ctx.url), 1),
        _createVNode("div", {
          class: "flex items-center mt-6 mb-4 text-sm text-primary-500 transition-colors duration-300 cursor-pointer hover:text-primary-600",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showMeetingId && _ctx.showMeetingId(...args)))
        }, [
          _hoisted_8,
          _hoisted_9
        ]),
        (_ctx.isDisplayMeetingId)
          ? (_openBlock(), _createBlock("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, [
                  _createVNode(_component_m_icon, {
                    type: "warning",
                    size: "6"
                  }),
                  _hoisted_13
                ]),
                _hoisted_14
              ]),
              _hoisted_15,
              _createVNode("p", _hoisted_16, [
                _hoisted_17,
                _createVNode("span", _hoisted_18, _toDisplayString(_ctx.meetingId), 1)
              ]),
              _hoisted_19
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["onClose"]))
}